import { TAB_NAMES } from '../../utils/accessMapConstants';
import { SEARCH_RECORD_TYPE } from './searchPrefsConstants';
import { getAllStatusesForRecordType, resetUnsupportedFilterFields } from './searchPrefsMapper';

/** Dropdown label for the option that clears the active preset. */
export function getNoPresetOptionLabel() {
  return 'No preset';
}

export function getDefaultActiveTabForRecordType(recordType) {
  return recordType === SEARCH_RECORD_TYPE.COLLECTION
    ? TAB_NAMES.MY_COLLECTIONS
    : TAB_NAMES.MY_PROJECTS;
}

/** Unfiltered filter state: all statuses, any role, any date, default tab. */
export function buildDefaultFilterState(recordType) {
  const allStatuses = getAllStatusesForRecordType(recordType);
  return {
    activeTab: getDefaultActiveTabForRecordType(recordType),
    selectedStatuses: [...allStatuses],
    appliedRoleFilter: null,
    queryFromDay: '',
    queryToDay: '',
    dateFilterMode: 'any',
  };
}

/** Reset filter context to the unfiltered default (no preset applied). */
export function applyDefaultFilters(actions, recordType) {
  resetUnsupportedFilterFields(actions);
  actions.setActiveTab?.(getDefaultActiveTabForRecordType(recordType));
  resetTabScopedFilterFields(actions, recordType);
}

/** Reset preset-backed filters without changing the active tab (e.g. on tab switch). */
export function resetFiltersKeepingTab(actions, recordType) {
  resetUnsupportedFilterFields(actions);
  resetTabScopedFilterFields(actions, recordType);
}

function resetTabScopedFilterFields(actions, recordType) {
  actions.setSelectedStatuses?.([...getAllStatusesForRecordType(recordType)]);

  if (actions.applyRolePreset) {
    actions.applyRolePreset([]);
  } else {
    actions.clearRoleFilters?.();
  }
}
